/**
 * 公共方法
 */
exports.install = function (Vue,options){
    var _this=Vue.prototype;
    var Common=Vue.prototype.$common={};
    
    /**
     * 在新页面打开
     * @param {*} $this
     * @param {*} routeName
     * @param {*} param 参数对象，对象格式
     */
    Common.OpenNewPage=function($this,routePath,param){
        let routeData=$this.$router.resolve({
            path:routePath,
            query:param
        });
        window.open(routeData.href,'_blank');
    }
    Common.setSessionStorage=function(key,objData){
        if(typeof objData=='string'){
            sessionStorage.setItem(key,objData);
        }
        else{
            sessionStorage.setItem(key,JSON.stringify(objData));
        }
        
    }
    Common.datetampToTime=function(val){
        var date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
        var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' '
        var h = date.getHours() + ':'
        var m = date.getMinutes() + ':'
        var s = date.getSeconds()
        return Y+M+D+h+m+s
    },
    Common.monthtampToTime=function(val){
        var date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
        var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate())
        return Y+M+D
    },
    Common.mampToTime=function(val){
        var date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) 
        return Y+M
    },
    //图片转化
    Common.imgUrl=function(val){
        if(val){
            var val = val.split('/');
            var valNum = val.length;
            var valid;
            for(var i=0;i<valNum;i++){
                valid = val[valNum-1]
            }
            return 'http://129.211.113.90:8080/uploadFile/' + valid
         }else{
             return 'static/img/zanwu2.png'
         }
    },
    //时间戳
    Common.transdate=function(val){
            var date = new Date(val);
          // 有三种方式获取
             var time1 = date.getTime();
             var time2 = date.valueOf();
             var time3 = Date.parse(date);
         return time1
    }
    

    
}



// WEBPACK FOOTER //
// ./src/common/date.js